export default __webpack_public_path__ + "static/media/avatar_52.0891025b.png";